export default __webpack_public_path__ + "static/media/check.675bde73.svg";